// extracted by mini-css-extract-plugin
export default {"externo":"ListScroll_externo__qyGDk","list":"ListScroll_list__zaceJ","divVideo":"ListScroll_divVideo__JLOLD","video":"ListScroll_video__N7lfx"};